module.exports = __webpack_public_path__ + "static/media/snowflake_logo-01-01 (1) (1).9b03dafc.jpg";